module.exports = __webpack_public_path__ + "static/media/galeryAbout11.0fab37a1.jpg";